// leaf-town - core: namespace, math, save data (the input half lives in 1-endpoints/input/input.js)
(function () {
  'use strict';
  const G = (window.G = { W: 384, H: 216, T: 16, time: 0, frame: 0 });

  // ---------- math ----------
  G.clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
  G.lerp = (a, b, t) => a + (b - a) * t;
  G.approach = (v, target, step) => (v < target ? Math.min(v + step, target) : Math.max(v - step, target));
  G.rand = (a = 1, b) => (b === undefined ? Math.random() * a : a + Math.random() * (b - a));
  G.randi = (a, b) => Math.floor(G.rand(a, b + 1));
  G.pick = (arr) => arr[(Math.random() * arr.length) | 0];
  G.sign = (v) => (v < 0 ? -1 : v > 0 ? 1 : 0);
  G.dist = (ax, ay, bx, by) => Math.hypot(bx - ax, by - ay);
  G.damp = (a, b, rate, dt) => G.lerp(a, b, 1 - Math.exp(-rate * dt));
  // deterministic hash -> [0,1)
  G.hash = (x, y = 0, s = 0) => {
    let h = (x | 0) * 374761393 + (y | 0) * 668265263 + (s | 0) * 2147483647;
    h = (h ^ (h >>> 13)) * 1274126177;
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
  };
  G.rng = (seed) => {
    let a = seed >>> 0;
    return () => {
      a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  };
  G.overlap = (a, b) => a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
  G.ease = {
    out: (t) => 1 - (1 - t) * (1 - t) * (1 - t),
    in: (t) => t * t * t,
    io: (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),
    back: (t) => 1 + 2.70158 * Math.pow(t - 1, 3) + 1.70158 * Math.pow(t - 1, 2),
    elastic: (t) => (t === 0 || t === 1 ? t : Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * ((2 * Math.PI) / 3)) + 1),
    bounce: (t) => {
      const n = 7.5625, d = 2.75;
      if (t < 1 / d) return n * t * t;
      if (t < 2 / d) return n * (t -= 1.5 / d) * t + 0.75;
      if (t < 2.5 / d) return n * (t -= 2.25 / d) * t + 0.9375;
      return n * (t -= 2.625 / d) * t + 0.984375;
    },
  };
  G.fmtTime = (s) => {
    const m = Math.floor(s / 60), r = s - m * 60;
    return m + ':' + (r < 10 ? '0' : '') + r.toFixed(2);
  };

  // ---------- save ----------
  const SAVE_KEY = 'leaf-town-v3';
  const fresh = () => ({
    v: 1, started: false, hero: 'sprout', name: '',
    cleared: {},            // level id -> true
    sparks: {},             // level id -> [bool,bool,bool]
    best: {},               // level id -> seconds
    tools: { bash: false, agents: false, sudo: false, opus: false },
    seen: {},               // cutscenes / world cards / boss intros
    node: 0,                // cursor on the map
    deaths: 0, tokens: 0, finished: false,
    opt: { music: 0.7, sfx: 0.8, voice: 1, shake: 1 },
  });
  G.save = {
    data: fresh(),
    load() {
      try {
        const raw = localStorage.getItem(SAVE_KEY);
        if (raw) {
          const d = JSON.parse(raw), f = fresh();
          this.data = Object.assign(f, d, { tools: Object.assign(f.tools, d.tools), opt: Object.assign(f.opt, d.opt) });
        }
      } catch (e) { /* private mode etc. - play without saving */ }
    },
    write() { try { localStorage.setItem(SAVE_KEY, JSON.stringify(this.data)); } catch (e) { /* ignore */ } },
    reset() { const opt = this.data.opt; this.data = fresh(); this.data.opt = opt; this.write(); },
    sparkCount() { let n = 0; for (const k in this.data.sparks) for (const s of this.data.sparks[k]) if (s) n++; return n; },
  };
})();

